export default __webpack_public_path__ + "static/media/template_blank.0f837d11.png";